module.exports = __webpack_public_path__ + "static/media/about.8fb0e5fd.png";